const {
  addTabsInCode,
  isNotEquivalent,
} = require('../base-live-demo-component/utils');
const {
  defaultAdvancedColorsOptions,
  defaultAdvancedTextOptions,
} = require('./componentProps');
const { getFrontSnippetPlaceholder } = require('./utils');

const componentCodeFront = (formData, i18n) => {
  try {
    return [
      {
        code: `
    <html>
    <head>
      <script src="https://sdk.mercadopago.com/js/v2"></script>
    </head>
    <body>
      <div id="statusScreenBrick_container"></div>
      <script>
        const mp = new MercadoPago('YOUR_PUBLIC_KEY', { // Add your public key credential
          locale: '${formData.language}'
        });
        const bricksBuilder = mp.bricks();
        const renderStatusScreenBrick = async (bricksBuilder) => {
          const settings = {
            initialization: {
              paymentId: '1234567890', // Payment identifier, from which the status will be checked
            },
            customization: {
              visual: {
                    ${!formData.showExternalReference ? 'showExternalReference: false,' : ''}
                    ${!formData.hideStatusDetails ? 'hideStatusDetails: true,' : ''}
                    ${!formData.hideTransactionDate ? 'hideTransactionDate: true,' : ''}
                    style: {
                    theme: ${`'${formData.theme}'` || 'default'}, // 'default' | 'dark' | 'bootstrap' | 'flat'
                    ${formData.customVariables
                                            !== JSON.stringify(defaultAdvancedColorsOptions, null, 2)
    ? addTabsInCode(
      JSON.stringify(
        isNotEquivalent(
          JSON.parse(formData.customVariables),
          defaultAdvancedColorsOptions,
        ),
        null,
        2,
      ).slice(1, -1),
      8,
    ).replace(/"(\w+)"\s*:/g, '$1:')
    : ''
}
                    },
                    ${formData.customTexts !== JSON.stringify(defaultAdvancedTextOptions, null, 2)
    ? `texts: {
                                ${addTabsInCode(JSON.stringify(isNotEquivalent(JSON.parse(formData.customTexts), defaultAdvancedTextOptions), null, 2).slice(1, -1), 9).replace(/"(\w+)"\s*:/g, '$1:')}}`
    : ''
}
                },
              backUrls: {
                'error': '<http://<your domain>/error>',
                'return': '<http://<your domain>/homepage>'
              }
            },
            callbacks: {
              onReady: () => {
                // Callback called when Brick is ready
              },
              onError: (error) => {
                // Callback called for all Brick error cases
              },
            },
          };
          window.statusScreenBrickController = await bricksBuilder.create('statusScreen', 'statusScreenBrick_container', settings);
        };
        renderStatusScreenBrick(bricksBuilder);
      </script>
    </body>
    </html>
    `.replace(/^\s*[\r\n]/gm, ''),
        type: 'html',
        name: 'html',
      },
    ];
  } catch (e) {
    return [{
      code: getFrontSnippetPlaceholder(formData, i18n).replace(/^\s*[\r\n]/gm, ''),
      type: 'html',
      name: 'html' }];
  }
};

module.exports = componentCodeFront;
